import * as React from "react";
import { useEffect, useState, FC } from "react";
import "../Styles/InputCode.css"
import axios from 'axios';
import { Lock } from "react-feather";


interface InputCodeProps {
    solicitCode: (valid: boolean) => any;
    user: any;
}

export const InputCode:FC<InputCodeProps> = ({solicitCode, user}) =>{
    const [maxlen, setMaxlen] = useState<boolean>(false);
    const [code, setCode] = useState<string>("");
    const [error, setError] = useState(null);

    useEffect(() => {
        if(code.length === 4) {
            checkCode();
        }
    }, [code])
    
    const checkCode = async() => {
        try {
            let resp = await axios.post(`/access_code`, {
                fields: {
                code: Number(code),
                device_id: user.device_id
                }
            });
            //console.log(resp.data);
            if(!resp.data.ok) {
                setCode("");
                setMaxlen(false);
                setError("Codigo incorrecto");
            }
            solicitCode(resp.data.ok);
        } catch (error) {
            console.error(error);
            setError("Ocurrio un error, intenrelo mas tarde");
        }
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        }}>
            <div className="mt-4">
                <h4><span className="badge badge-secondary">Codigo de seguridad <Lock size={20} /> </span></h4>
                <input  type="number" name="input code" value={code} id="inputcode"  disabled={maxlen} onChange={e => {
                    if(e.target.value.length > 0) {
                        setError(null);
                    }
                    setCode(e.target.value);
                    setMaxlen(e.target.value.length > 3);
                } }/>

            </div>
            {
              error && (<div className="alert alert-danger" role="alert">
              {error}
            </div>)
            }
            <div className="row w-100 ">
                <span className="badge badge-light">Solcita el codigo de acceso al encargado de la tienda.</span>
            </div>
        </div>
    )
}
